export const COMPLAIN_CATEGORY_CONSTANT = {
  //charts
  COMPLAIN_CATEGORY_COUNT: "/dashboard/complain/count/category",
};
